import { memo, useEffect, useState } from 'react'
import { isArray, isEmpty } from 'lodash';
import { MessageTypeConstants } from '../../../services/bot/Message';
import { uuidGenerator } from '../../../utils/general';
import { getAuthData } from '../../../services/storage/LocalStorage';
import { processSendMessage } from '../../../services/bot/conversation/SendMessage';
import { useDispatch, useSelector } from 'react-redux';
import {  setButtonLoader, setBotWaitLoaderWithShimmer } from '../../../state/actions/loader';
import { handleMessageTypeTable } from '../../../state/actionsHelpers/tabStackActionsHelpers/message-type-table';
import { handlePromptOnClose, setTabState } from '../../../state/actions/tabStack';
import { removeTableMessage } from '../../../state/actions/chats';
import useAudio from '../../../utils/AudioElement';
import FMTableAttachment from './Attachment';
import SelectionActionButton from '../../../components/common/SelectionActionButton';
import FMTableComponent from './Table';
import CustomToolbar from '../../common/CustomToolBar';
import ConfirmDeleteTabClose from '../../ui/Modals/ModalPopup';
import { setAddManuallayRow } from '../../../state/actions/filters';


const FMTable = ({handleTimeBasedSearchCallback = () => { }, ...props}) => {
    const message = props.message && isArray(props.message) ? props.message : props.message?.message || props.message?.rows || [];
    const options = props.options || props.message?.options || {};
    const conversation = props.conversation ?? props?.message?.conversation ?? message?.conversation
    const parentTabId = props.parentTabId ? props.parentTabId : options.tabId;
    const parentDocId = props.parentDocId ?? options.parentDocId;
    const messageType = props.messageType ?? message?.messageType ?? MessageTypeConstants.MESSAGE_TYPE_TABLE;
    const parentOptions =  props.parentOptions ?? null;

    const [selectedRow, setSelectedRow] = useState([]);
    const [isSectionId, setIsSectionId] = useState(false);
    const [showMandatory, setShowMandatory] = useState(false);
    const buttonLoader = useSelector((state) => state.loader.buttonLoader);
    const deleteConfirmation = useSelector((state) => state?.chats?.deleteConfirmation);
    const [selectedAll, setSelectedAll] = useState(false);
    const [showCheckBox, setShowCheckBox] = useState(false);
    const [rows, setRows] = useState([]);
    const [confirmDeleteModal, setConfirmDeleteModal] = useState({ show: false });
    const [selectedAction, setSelectedAction] = useState("Select Action");

    const defaultUserTimezone = "Etc/UTC";
    const { user = {} } = getAuthData();
    const dispatch = useDispatch();

    useEffect(() => {
        if (options?.sectionId && options?.sectionId != null) {
            setIsSectionId(true);
        }
    }, []);

    useEffect(() => {
        if (deleteConfirmation) {
            setConfirmDeleteModal({ show: true, ...deleteConfirmation?.message })
        }
    }, [deleteConfirmation]);



    //To close Delete confirmation modal and remove table message
    useEffect(() => {
        if (!buttonLoader && !deleteConfirmation) {
            setConfirmDeleteModal({ show: false });
        }
    }, [buttonLoader]);


    const handleAction = (action, content = null, oldContent = null, docId = null, newlyAddedRow = null, selectionAction = null, isDisableRefresh) => {
        let sendActionObj = {
            messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
            message: {
                controlId: options.controlId,
                tabId: parentTabId ? parentTabId : options.tabId,
                parentDocId: options?.docId || parentDocId,
                selectedAction:selectionAction,
                action,
                content,
                oldContent,
                docId,
                sectionId: options?.sectionId || null,
                tz: user?.userTimezone || defaultUserTimezone,
            },
            messageId: uuidGenerator(),
        };
        dispatch(setTabState(false))
        dispatch(setAddManuallayRow(false));
        if (isDisableRefresh) dispatch(setBotWaitLoaderWithShimmer(true));
        if (action !== "onDelete" && !isDisableRefresh) dispatch(setBotWaitLoaderWithShimmer(true));
        if (newlyAddedRow) sendActionObj = { ...sendActionObj, newRow: newlyAddedRow }
        processSendMessage(sendActionObj);
    };


    const handleInlineFormAction = (action, docId = null, currentField = null, content = null, newlyAddedRow) => {
        let sendActionObj = {
            messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
            message: {
                controlId: options.controlId,
                tabId: parentTabId ? parentTabId : options.tabId,
                parentDocId: options?.docId || parentDocId,
                action,
                content,
                currentField,
                docId,
                sectionId: options?.sectionId || null,
                tz: user?.userTimezone || defaultUserTimezone,
            },
            messageId: uuidGenerator(),
        }

        if (newlyAddedRow) sendActionObj = { ...sendActionObj, newRow: newlyAddedRow }
        dispatch(setTabState(false))
        dispatch(setAddManuallayRow(true));
        processSendMessage(sendActionObj);
    };

    const handleDeleteAction = (action, content = null, oldContent = null) => {
        const { controlId = null, tabId = null } = confirmDeleteModal;

        const responseChat = {
            messageType: MessageTypeConstants.MESSAGE_TYPE_AUTHORIZATION_REQUEST_RESPONSE,
            message: {
                controlId,
                tabId,
                action,
                content,
                oldContent,
            },
        };
        dispatch(setTabState(false))
        processSendMessage(responseChat);
        setConfirmDeleteModal({ show: false });
        dispatch(setButtonLoader(true));
        dispatch(removeTableMessage());
        setSelectedAction("Select Action")
        setSelectedRow([])
    };

    const handleCancelDelete = () => {
        dispatch(removeTableMessage());
        setConfirmDeleteModal({ show: false });
        setSelectedAction("Select Action")
    };

    const handleConfirmDelete = () => {
        // Filter the row to delete
        let row = message.find((val) => (Object.keys(val)[0] === confirmDeleteModal?.docIdTarget));
        handleRowDelete(row);
    };

    const handleRowDelete = (row) => {
        handleAction(
            "onDelete",
            row,
            null,
            Object.keys(row)[0],
            null
        );
        let updatedRow = message.filter((item) => {
            if (Object.keys(item)[0] !== Object.keys(row)[0]) {
                return item;
            }
        });
        let optionsDetails = options;

        let formMessage = {
            message: {
                update: updatedRow,
            },
            options: {
                action: "change",
                controlId: optionsDetails.controlId,
                tableId: optionsDetails.tableId,
                tabId: parentTabId ? parentTabId : optionsDetails.tabId,
                parentDocId,
                parent: optionsDetails.parent,
                docId: Object.keys(row)[0],
                sectionId: optionsDetails.sectionId ? optionsDetails.sectionId : null,
            },
        };
        dispatch(setTabState(false))
        dispatch(handleMessageTypeTable(conversation, formMessage, true));
        handleCancelDelete();
        dispatch(handlePromptOnClose(conversation));
    };
    const handleSelectAllRows = () => {
        const newValue = !selectedAll;
        setSelectedAll(newValue);
        if (newValue) {
            setSelectedRow(rows); // select all
        } else {
            setSelectedRow([]); // deselect all (or null if that's what you prefer)
        }
    };


    useEffect(() => {
        const readOnlyFields = {};
        // console.log("window.lastMsgFields : ", window.lastMsgFields)
        window.lastMsgFields &&
            window.lastMsgFields.map((field) => (readOnlyFields[field.id] = field));

        if (message) {
            // changing the values based on the message received
            if (window.lastMsgFields && window.lastDocIdChanged) {
                const readOnlyKeys = Object.keys(readOnlyFields);
                message = message.map((ele) => {
                    let fields = ele[window.lastDocIdChanged]?.fields;
                    if (fields) {
                        fields = fields.map((field) => {
                            // if the field present in the message change it
                            if (readOnlyKeys.includes(field.id)) {
                                field.readOnly = readOnlyFields[field.id].readOnly;
                            }
                            return field;
                        });
                        ele[window.lastDocIdChanged].fields = fields;
                    }
                    return ele;
                });
            }
            setRows(message);
        }

        return () => {
            if (!options?.openDrawer) setRows([]);
        };
    }, [message, options]);


    const handleSelectionAction = (action,selectionAction=null) => {
        let formattedRow = [];

        for (let i in selectedRow) {
            const singleRow = selectedRow[i];
            const rowId = Object.keys(singleRow)[0];
            const currentObj = singleRow[rowId];

            let formatRowObj = {}
            currentObj.fields.forEach((item) => {
                formatRowObj[item.id] = item.value;
            });
            formattedRow.push(formatRowObj)
        }

        handleAction(action, formattedRow, null,null,null,selectionAction);
    };

    if (!isEmpty(options)) {
        return (
            <div className="table-container">
                {options.acceptAttachments && (
                    <FMTableAttachment
                        conversation={conversation}
                        parentTabId={parentTabId}
                        parentDocId={parentDocId}
                        options={options}
                        message={message}
                        showMandatory={showMandatory}
                        handleInlineFormAction={handleInlineFormAction}
                        setShowMandatory={setShowMandatory}
                    />
                )}
                <div className='table-container-sub'>
                    {messageType === MessageTypeConstants.MESSAGE_TYPE_TABLE
                        ?
                        <div className="table-header">
                            <div className='flex items-center gap-3'>
                                {messageType === MessageTypeConstants.MESSAGE_TYPE_TABLE && <h2 className='text-size-14 font-semibold text-black mb-2 mt-2'>
                                    {options?.title || ''}
                                </h2>}
                                <SelectionActionButton
                                    options={options}
                                    selectedRow={selectedRow}
                                    handleSelectionAction={handleSelectionAction}
                                    selectedAction={selectedAction}
                                    setSelectedAction={setSelectedAction}
                                    />
                            </div>
                            <CustomToolbar
                                options={options}
                                handleAction={handleAction}
                                messageType={messageType}
                                handleSelectAllRows={handleSelectAllRows}
                                parentTabId={parentTabId}
                                parentDocId={parentDocId}
                                conversation={conversation}
                            />
                        </div>
                        :
                        <>
                            <CustomToolbar
                                options={options}
                                handleAction={handleAction}
                                messageType={messageType}
                                parentTabId={parentTabId}
                                handleSelectAllRows={handleSelectAllRows}
                                parentDocId={parentDocId}
                                conversation={conversation}
                                doTimeBaseSearchCallback={handleTimeBasedSearchCallback}
                            />
                        </>
                    }

                    <div className="table-body">
                        <FMTableComponent
                            message={message}
                            optionsDetails={options}
                            handleSelectAllRows={handleSelectAllRows}
                            selectedRow={selectedRow}
                            setSelectedRow={setSelectedRow}
                            conversationId={conversation}
                            parentTabId={parentTabId}
                            parentDocId={parentDocId}
                            showMandatory={showMandatory}
                            handleAction={handleAction}
                            showCheckbox={showCheckBox}
                            setShowMandatory={setShowMandatory}
                            handleInlineFormAction={handleInlineFormAction}
                            setDisableParentSaveButton={props.setDisableSubmit || null}
                            disableSubmitFromParent={props.disableSubmit || null}
                            parentOptions={parentOptions}
                        />
                    </div>
                </div>

                {confirmDeleteModal.show && (
                    <ConfirmDeleteTabClose
                        showModal={confirmDeleteModal.show}
                        confirmDeleteModal={confirmDeleteModal}
                        handleConfirmDelete={() => handleDeleteAction("confirm", null, null)}
                        handleCancelDelete={handleCancelDelete}
                    />
                )}
            </div>
        )
    };

    return null
};

export default FMTable;
